import { useState } from 'react';
import { works } from '../data/works';
import './HSWorksGallery.css';

const categories = ['すべて', '看板・サイン', 'LEDビジョン', 'LED照明', 'LED表示設備', '防犯カメラ', '駐車場設備', '金物製作'];

export default function HSWorksGallery() {
  const [category, setCategory] = useState('すべて');
  const [showAll, setShowAll] = useState(false);
  const filtered = category === 'すべて' ? works : works.filter((work) => work.category === category);
  const visible = showAll ? filtered : filtered.slice(0, 9);

  const chooseCategory = (next) => { setCategory(next); setShowAll(false); };

  return (
    <section className="hs-works-section" id="works" aria-labelledby="hs-works-title">
      <div className="container">
        <div className="hs-works-heading">
          <span className="section-eyebrow">WORKS</span>
          <h2 id="hs-works-title" className="section-h2">施工実績</h2>
          <p className="section-lead">看板・サイン、LEDビジョン、LED表示設備などの施工事例をご紹介します。</p>
        </div>
        <div className="hs-works-filters" aria-label="施工実績のカテゴリー">
          {categories.map((item) => (
            <button key={item} type="button" onClick={() => chooseCategory(item)}
              className={`hs-works-filter ${category === item ? 'is-active' : ''}`}
              aria-pressed={category === item}>{item}</button>
          ))}
        </div>
        {visible.length ? (
          <div className="hs-works-grid">
            {visible.map((work) => (
              <a href={work.full} key={work.id} className="hs-works-card" target="_blank"
                rel="noopener noreferrer" aria-label={`${work.title}の写真を拡大表示（別タブ）`}>
                <div className="hs-works-image-frame">
                  <img src={work.thumbnail} alt={work.title} loading="lazy" decoding="async" />
                </div>
                <div className="hs-works-card-content">
                  <span className="hs-works-category">{work.category}</span>
                  <h3>{work.title}</h3>
                  <span className="hs-works-zoom">写真を拡大する</span>
                </div>
              </a>
            ))}
          </div>
        ) : <p className="hs-works-empty">現在、このカテゴリーの掲載事例はありません。</p>}
        {filtered.length > 9 && (
          <div className="hs-works-more-wrap">
            <button className="hs-works-more" type="button" onClick={() => setShowAll(v => !v)}>
              {showAll ? '表示を少なくする' : `もっと見る（全${filtered.length}件）`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
